<div class="quick-search-panel">
  
  <mat-form-field>
      <mat-select #matSelectInfiniteScroll
                  msInfiniteScroll
                  (selectionChange)="handleShapeClick($event)"
                  (infiniteScroll)="getNextBatch()"
                  [formControl]="dataControl"
                  [ngClass]="{'alignTop': alignTop }"
                  placeholder="">

                  <div *ngIf="currentShapeAsQuickShape | async as currentshape">
                    <div *ngIf="currentshape && context !== 'shape-switch'" class="current-shape-container">
                      <div class="current-shape-btn">
                          <div class="current-shape-block">
                              <mat-option
                                  [value]="currentshape"
                                  class="current-shape-item">
                                  <plus-create-item
                                      [item]="currentshape"
                                      [canvasWidth]="35"
                                      [canvasAreaWidth]="canvasAreaWidth"
                                      draggable="false">
                                  </plus-create-item>
                                  <span class="caption current-shape-title" translate>LABELS.ADD_ANOTHER</span>
                              </mat-option>
                          </div>
                      </div>
                      <div class="separator"></div>       
                    </div>
                  </div>
      <div class="search-wrapper">         
            <ngx-mat-select-search
              #search
              [formControl]="searchCtrl"
              placeholderLabel="{{translate('LABELS.SEARCH_SHAPES') | async }}"
              class="search-panel quick-search-panel-input-container"
              noEntriesFoundLabel="{{translate('LABELS.NO_SEARCH_RESULTS') | async }}">
              <div ngxMatSelectSearchIcon class="search-icon-container fx-center-all">
                <svg class="nu-icon nu-ic-search-thin medium-grey">
                  <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-search-thin"></use>
                </svg>
              </div>
              <div ngxMatSelectSearchClear class="search-clear-icon-container fx-center-all">
                <svg class="nu-icon nu-icon-small medium-grey">
                  <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-close"></use>
                </svg>
              </div>
            </ngx-mat-select-search>
        </div>
        <div class="search-result-block" *ngFor="let searchBlock of searchResults | async">
          <div *ngIf= "searchBlock.category !== 'Generate with '">
            <mat-option disabled class="caption category-title">
              <span class="caption">{{searchBlock?.category}}</span>
            </mat-option>
            <div style="display:flex;" class="items-container">
              <mat-option *ngFor="let i of searchBlock?.results" [value]="i" class="item">
                <plus-create-item #tile
                  *ngIf="i.type === 'shape'"
                  [item]="i"
                  [canvasWidth]="35"
                  [canvasAreaWidth]="canvasAreaWidth"
                  draggable="false">
                </plus-create-item>
              </mat-option>
            </div>
          </div> 
          <div class="viz-container" *ngIf= "searchBlock.category === 'Generate with '">
            <div class="separator"></div> 
            <mat-option disabled class="caption category-title">
              <span class="caption">{{searchBlock?.category}}</span>
              <svg class="nu-icon nu-icon-small">
                <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-vizs"></use>
              </svg>
            </mat-option>
            <div class="items-container">
              <mat-option *ngFor="let i of searchBlock?.results" [value]="i" class="item">
                  <plus-create-item #tile
                    *ngIf="i.type === 'viz'"
                    [item]="i"
                    [canvasWidth]="35"
                    [canvasAreaWidth]="canvasAreaWidth"
                    draggable="false">
                  </plus-create-item>
              </mat-option>
            </div>
          </div>
        </div>
      </mat-select>
    </mat-form-field>
</div>
